import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(315deg, #E65F3D 0%, #FFAD75 100%)',
} as const

export const resources = {
  homeBg: '/images/freefic/home-bg.svg',
  spikeletL: '/images/freefic/ranking/spikelet_l.png',
  spikeletR: '/images/freefic/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
